import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import { Column } from 'components/shared/Layout';
import { ConfirmButton } from 'components/ui/Button';
import { FormattedMessage } from 'react-intl';
import { StyledColumn } from '../AfterSalesWarning.styles';

const PendingPaymentsWarning = ({ reference, currency }) => {
  const history = useHistory();

  return (
    <>
      <Column>
        <FormattedMessage id="afterSalesWarning.pendingPayments" />
      </Column>
      <StyledColumn span={3}>
        <ConfirmButton data-cy="revert-changes" onClick={() => history.push(`/exchange/${reference}/payment?currency=${currency}`)}>
          <FormattedMessage id="afterSalesWarning.seeSplitPayments" />
        </ConfirmButton>
      </StyledColumn>
    </>
  );
};

PendingPaymentsWarning.propTypes = {
  reference: PropTypes.string,
  currency: PropTypes.string
};

export default PendingPaymentsWarning;
